import numeral from 'numeral'
import './locales'
import moneyFormats from './moneyFormats'
import percentageFormats from './percentageFormats'

export default function(number, format, customLocale) {
  const locale = customLocale || global.currentLocale || 'es_CL'
  numeral.locale(locale)
  let numberFormat = format

  if (format === 'money') {
    numberFormat = moneyFormats[locale]
  } else if (format === 'percentage') {
    numberFormat = percentageFormats[locale]
  }

  return numeral(number).format(numberFormat)
}
